document.addEventListener('DOMContentLoaded', function() {
    const increaseBtn = document.getElementById('increaseBtn');
    const decreaseBtn = document.getElementById('decreaseBtn');
    const quantityInput = document.getElementById('quantityInput');
    if (!increaseBtn || !decreaseBtn || !quantityInput) return;

    increaseBtn.addEventListener('click', function() {
        let quantity = parseInt(quantityInput.value, 10);
        if (quantity < 6) {
            quantity++;
        } else {
            quantity += 6;
        }
        quantityInput.value = quantity;
    });
   
    decreaseBtn.addEventListener('click', function() {
      let quantity = parseInt(quantityInput.value, 10);
      
      if (quantity <= 6) {
          quantity = Math.max(1, quantity - 1);
      } else {
          quantity -= 6;
      }
      
      quantityInput.value = quantity;
    });
});

